import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Button from "../Buttons";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const AlreadyBookedSlotModal = ({ closeModal, handleContinue }) => {
  return (
    <ModalContainer>
      <ModalTitle>Slots Booked</ModalTitle>
      <ModalText>
        Some of the slots you selected has been booked already, Please try some
        other slots/date.
      </ModalText>
      <ButtonContainer>
        <Button
          label="Ok"
          variant="outlined"
          backgroundColor={Colors.white}
          size="large"
          fontColor={Colors.aqua}
          padding={"0.5rem 0.5rem"}
          cursorType="pointer"
          onClick={handleContinue}
        />
        <Button
          label="Close"
          variant="filled"
          backgroundColor={Colors.aqua}
          size="large"
          fontColor={Colors.white}
          padding={"0.5rem 0.5rem"}
          cursorType="pointer"
          onClick={closeModal}
        />
      </ButtonContainer>
    </ModalContainer>
  );
};

const ModalContainer = styled.div`
  text-align: center;
  padding: 1rem;
`;

const ModalTitle = styled.div`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-family: Poppins;
`;

const ModalText = styled.div`
  font-size: 1rem;
  margin-bottom: 1rem;
  font-family: Poppins;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export default AlreadyBookedSlotModal;
